/**
 * Explains why an order's billing requirement cannot be changed.
 *
 * A locked billing requirement does not imply a required one. Most locked
 * types are always required, but an evaluation signature request is locked
 * because it is never required: claim readiness ignores it outright, so the
 * copy states the order's actual value rather than assuming it.
 */
export function getLockedBillingRequirementMessage(
  orderTypeDisplayName: string,
  requiredForBilling: boolean
): string {
  return `${orderTypeDisplayName} is ${
    requiredForBilling ? 'always' : 'never'
  } required for billing.`;
}
